<div [ngStyle]="{ 'background-color': isAdminRoute ? '#f0f0f0' : 'transparent' }" 
     style="display: flex; flex-direction: column; height: 100vh; position: relative;">
  <app-header *ngIf="!(showAdminItens$ | async) || !(isAuthenticated$ | async) || !(isAdmin$ | async) || (isTechView$ | async) || !isAdminRoute" style="z-index: 1000;"></app-header>
  <div style="display: flex; flex: 1; overflow: hidden;">
    <app-sidebar *ngIf="(showAdminItens$ | async) && (isAuthenticated$ | async) && (isAdmin$ | async) && !(isTechView$ | async) && isAdminRoute"
                  style="position: relative; z-index: 10; background-color: #ffffff;">
    </app-sidebar>
    <div class="content" style="flex: 1; display: flex; flex-direction: column;">
      <div class="subheader" style="padding: 3px; display: flex; justify-content: space-between; align-items: center;">
        <div style="display: flex; align-items: center;">
          <h1 *ngIf="isDashboardRoute" style="margin: 0;">Dashboard</h1>
          <h1 *ngIf="isResourceRoute" style="margin: 0;">Resource Database</h1>
          <h1 *ngIf="isStatisticsRoute" style="margin: 0;">Statistics</h1>
        </div>
        <div style="display: flex; gap: 10px;">
          <app-switch-profile *ngIf="(showAdminItens$ | async) && (isAuthenticated$ | async) && (isAdminAndTech$ | async) && !(isPunchOut$ | async)"></app-switch-profile>
          <app-user-profile *ngIf="(showAdminItens$ | async) && (isAuthenticated$ | async) && (isAdmin$ | async) && !(isTechView$ | async) && isAdminRoute"></app-user-profile>
        </div>
      </div>
      <main style="flex: 1; overflow-y: auto; padding: 10px;">
        <router-outlet></router-outlet>
      </main>
    </div>
  </div>

  <app-footer *ngIf="!(showAdminItens$ | async) || !(isAuthenticated$ | async) || !(isAdmin$ | async) || (isTechView$ | async) || !isAdminRoute"></app-footer>
</div>